module.exports = __webpack_public_path__ + "static/media/Rich Cruz Headshot.24ac0d70.jpeg";